export const getSidebar = (state: any) => state.sidebar;
export const getToggle = (state: any) => getSidebar(state).get('toggle');